import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class SystemCalendarBloc extends BaseBloc {
  private readonly eventsBloc = resolve(Blocs.events);
  private readonly userBloc = resolve(Blocs.user);
  private readonly holidaysBloc = resolve(Blocs.companyHolidays);
  loading = new LoadingState();

  events$ = this.eventsBloc.events$;
  users$ = this.userBloc.allUsers$;
  /** Company holidays, rendered by name as locked bars on the calendar */
  holidays$ = this.holidaysBloc.items$;

  public onInit() {
    // Holidays are decoration — never let their fetch block the calendar
    return forkJoin([this.userBloc.fetchUsers(), this.holidaysBloc.fetchCompanyHolidays().pipe(catchError(() => of([])))]);
  }

  fetchEvents = this.eventsBloc.fetchEvents;
  moveEvent = this.eventsBloc.moveEvent;
  deleteEvent = this.eventsBloc.deleteEvent;

  importCalendar = this.eventsBloc.importCalendarTemplate;
  updateEventUserTask = this.eventsBloc.updateEventUserTask;
}
